module.exports = __webpack_public_path__ + "static/media/falcon.e0c8600c.png";